import { View } from '@play-co/timestep-core/ui';
import uiConfig from 'src/lib/ui/config';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { parseAmount } from 'src/lib/utils';
import { Social } from 'src/replicant/social';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import StateObserver from 'src/StateObserver';
import type { SocialSubFeature } from 'src/replicant/social/social.ruleset';
import {
  FlexBoxImageScaleView,
  getFlexNode,
} from '@play-co/timestep-core/flexbox';
import { Avatar } from './shared/Avatar';
import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { Feature } from 'src/replicant/analytics';

type Friend = {
  id: string;
  name: string;
  photo: string;
};

const ui = uiConfig.buruburu.invite.friendTile;

export class FriendTile {
  readonly view = new FlexBoxImageScaleView(ui.container);

  constructor(opts: {
    friend: Friend;
    onClick: () => Promise<void>;
    subFeature: SocialSubFeature;
  }) {
    const reward = Social.getters(
      StateObserver.getState().user,
    ).getInviteReward(opts.subFeature);

    // icon
    const icon = new Avatar({
      superview: this.view,
      ...ui.image,
      centerOnOrigin: false,
    });
    icon.updateImage(opts.friend.photo);
    getFlexNode(icon).updateStyle({
      marginLeft: 12,
      marginRight: 10,
    });

    const content = this.view.addSubview(
      new View({
        height: this.view.style.height,
      }),
    );
    getFlexNode(content).updateStyle({ flexGrow: 1 });

    // name
    const name = content.addSubview(
      new LangBitmapFontTextView({
        ...ui.name,
        localeText: () => opts.friend.name,
        verticalAlign: 'center',
      }),
    );

    // price
    content.addSubview(
      new LangBitmapFontTextView({
        ...ui.amount,
        localeText: () => `x${parseAmount(reward.value)}`,
      }),
    );

    // currency icon
    switch (reward.type) {
      case 'gems':
        content.addSubview(new ImageScaleView(ui.currencyGems));
        break;
      case 'energy':
        content.addSubview(new ImageScaleView(ui.currencyEnergy));
        break;
    }

    // invite cta
    // TODO This cta element should be passed in via composition so that the tile component can be used generically
    // eslint-disable-next-line no-constant-condition
    if (false) {
      const clickTrap = this.view.addSubview(
        new ButtonScaleView({
          onClick: opts.onClick,
          tracking: {
            feature: Feature.INVITE._,
            $subFeature: Feature.INVITE.INVITE_POPUP_MULTI_SELECT,
          },
        }),
      );
      getFlexNode(clickTrap).updateStyle({
        position: 'absolute',
        width: '100%',
        height: '100%',
      });
      name.style.width += ui.cta.width - 20;
    } else {
      const cta = this.view.addSubview(
        new ButtonScaleViewWithText({
          ...ui.cta,
          localeText: () => i18n('social.invite.referral.cta'),
          tracking: { feature: 'invite', $subFeature: 'referral' },
          onClick: opts.onClick,
        }),
      );
      getFlexNode(cta).updateStyle({ marginHorizontal: 20 });
    }
  }
}
